import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spin, Alert } from "antd";
import useAuthSessionGuard from "../hooks/useAuthSessionGuard";

const UpworkCallbackPage = () => {
  const { getAccessTokenOrLogout, handleUnauthorizedResponse } = useAuthSessionGuard();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const authorizationCode = urlParams.get("code");

      if (authorizationCode) {
        try {
          const token = await getAccessTokenOrLogout();
          if (!token) {
            return;
          }

          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/upwork/callback`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({ code: authorizationCode }),
            }
          );

          if (handleUnauthorizedResponse(response)) {
            return;
          }

          if (response.ok) {
            navigate("/admin");
          } else {
            setError(
              `Error posting authorization code: ${response.statusText}`
            );
          }
        } catch (error) {
          setError(`Error handling callback: ${error.message}`);
        } finally {
          setLoading(false);
        }
      } else {
        setError("Authorization code not found.");
        setLoading(false);
      }
    };

    handleCallback();
  }, [getAccessTokenOrLogout, handleUnauthorizedResponse, navigate]);

  if (loading) {
    return <Spin tip="Connecting Upwork..." />;
  }

  if (error) {
    return <Alert message="Error" description={error} type="error" showIcon />;
  }

  return null;
};

export default UpworkCallbackPage;
